import { Routes } from '@angular/router';

export const accountRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/account/account.component').then(m => m.AccountComponent),
    children: [

      { path: '', redirectTo: 'overview', pathMatch: 'full' },

      {
        path: 'overview',
        loadComponent: () =>
          import('./components/account/overview/overview.component')
            .then(m => m.OverviewComponent)
      },

      {
        path: 'profile',
        loadComponent: () =>
          import('./components/account/profile/profile.component')
            .then(m => m.ProfileComponent)
      },
      {
        path: 'security',
        loadComponent: () =>
          import('./components/account/security/security.component')
            .then(m => m.SecurityComponent)
      },
      {
        path: 'manage-address',
        loadComponent: () =>
          import('./components/account/manage-address/manage-address.component')
            .then(m => m.ManageAddressComponent)
      },
      {
        path: 'order-list',
        loadComponent: () =>
          import('./components/account/order-list/order-list.component')
            .then(m => m.OrderListComponent)
      },
      {
        path: 'returns',
        loadComponent: () =>
          import('./components/account/returns/returns.component')
            .then(m => m.ReturnsComponent)
      },
      {
        path: 'returns/:id',
        loadComponent: () =>
          import('./components/account/view-return-details/view-return-details.component')
            .then(m => m.ViewReturnDetailsComponent)
      },
      {
        path: 'newsletter',
        loadComponent: () =>
          import('./components/account/newsletter/newsletter.component')
            .then(m => m.NewsletterComponent)
      },
      {
        path: 'manage-team',
        loadComponent: () =>
          import('./components/account/manage-team/manage-team.component')
            .then(m => m.ManageTeamComponent)
      },
      {
        path: 'manage-payment',
        loadComponent: () =>
          import('./components/account/manage-payment/manage-payment.component')
            .then(m => m.ManagePaymentComponent)
      },
      {
        path: 'wishlist',
        loadComponent: () =>
          import('./components/account/order-wishlist/order-wishlist.component')
            .then(m => m.OrderWishlistComponent)
      },
      {
        path: 'recent-order',
        loadComponent: () =>
          import('./components/account/recent-orders/recent-orders.component')
            .then(m => m.RecentOrdersComponent)
      },
      {
        path: 'recent-order/view/:id',
        loadComponent: () =>
          import('./components/account/view-order-detail/view-order-detail.component')
            .then(m => m.ViewOrderDetailComponent)
      },
      {
        path: 'recent-order/replace/:id',
        loadComponent: () =>
          import('./components/account/view-order-detail/view-order-detail.component')
            .then(m => m.ViewOrderDetailComponent)
      },
      {
        path: 'quotes',
        loadComponent: () =>
          import('./components/account/my-quotes/my-quotes.component')
            .then(m => m.MyQuotesComponent)
      },
      // The redesigned My Quotes page has no tabs, so the quote cart the old page
      // held behind one now has its own path into what is left of that component.
      {
        path: 'quotes/cart',
        loadComponent: () =>
          import('./components/account/quotes/quotes.component')
            .then(m => m.QuotesComponent)
      },
      {
        path: 'quotes/view/:id',
        loadComponent: () =>
          import('./components/account/quote-detail/quote-detail.component')
            .then(m => m.QuoteDetailComponent)
      }
    ]
  }
];
